import type { MutationTree } from 'vuex';
import type { SigningTheme } from '@getaccept/lib-shared/src/signing-theme/types/theme';
import type { ThemeState } from './theme.types';
import { ThemeMutation } from './theme.types';

export const mutations: MutationTree<ThemeState> = {
  [ThemeMutation.SetTheme](state: ThemeState, theme: SigningTheme) {
    state.theme = theme;
  },
};
